import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/graphic/play.svg'


const _withScopeId = n => (_pushScopeId("data-v-339dedda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "photo-options" }
const _hoisted_2 = { class: "photo-options__header" }
const _hoisted_3 = { class: "photo-options__header-inner" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-close" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "photo-options__body" }
const _hoisted_8 = { class: "photo-block" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 3,
  class: "video-player--play",
  src: _imports_0,
  alt: "play icon"
}
const _hoisted_13 = {
  key: 0,
  class: "options-list"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-tablet-move" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-tablet-add" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-label-add" }, null, -1))
const _hoisted_17 = { class: "photo-options__controls" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "photo-options__controls-icon icon icon-check" }, null, -1))
const _hoisted_19 = {
  key: 0,
  ref: "labelsPopup",
  class: "label-input-wrapper"
}
const _hoisted_20 = { class: "label-input" }
const _hoisted_21 = { class: "label-input__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_label_input = _resolveComponent("app-label-input")!
  const _component_drive_create_case = _resolveComponent("drive-create-case")!
  const _component_app_cases_list_pop_up = _resolveComponent("app-cases-list-pop-up")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "photo-options__backdrop",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('on-cancel')), ["prevent"]))
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$localize('app.take.photo.options.title')), 1),
        _createElementVNode("a", {
          class: "back-link white",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('on-cancel')), ["prevent"]))
        }, _hoisted_6)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.croppedBlobToUrl, (cUrl, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            key: idx,
            class: "photo-block__item"
          }, [
            false
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(cUrl.coordinates?.rotate), 1))
              : _createCommentVNode("", true),
            (cUrl.type === 'IMAGE')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: cUrl.src,
                  alt: ""
                }, null, 8, _hoisted_10))
              : (_openBlock(), _createElementBlock("img", {
                  key: 2,
                  src: cUrl?.poster,
                  alt: ""
                }, null, 8, _hoisted_11)),
            (cUrl.type === 'VIDEO')
              ? (_openBlock(), _createElementBlock("img", _hoisted_12))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      (!_ctx.hideOptionsList)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", {
              class: "option-item",
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleAddToCaseModal && _ctx.handleAddToCaseModal(...args)), ["prevent"]))
            }, [
              _hoisted_14,
              _createTextVNode(_toDisplayString(_ctx.$localize('app.take.photo.options.add.to.case')), 1)
            ]),
            _createElementVNode("div", {
              class: "option-item",
              onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createCaseFromPhoto && _ctx.createCaseFromPhoto(...args)), ["prevent"]))
            }, [
              _hoisted_15,
              _createTextVNode(_toDisplayString(_ctx.$localize('app.take.photo.options.create.case')), 1)
            ]),
            _createElementVNode("div", {
              class: "option-item",
              onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addLabelsOpen && _ctx.addLabelsOpen(...args)), ["prevent"]))
            }, [
              _hoisted_16,
              _createTextVNode(_toDisplayString(_ctx.$localize('app.take.photo.options.label.photos')), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("a", {
        onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.$emit('on-done')), ["prevent"])),
        class: "done"
      }, [
        _hoisted_18,
        _createTextVNode(" " + _toDisplayString(_ctx.$localize('app.take.photo.options.finish.button')), 1)
      ])
    ]),
    (_ctx.showAddLabel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$localize('app.take.photo.options.view.labels')), 1),
            _createVNode(_component_app_label_input, {
              onOnInputDone: _ctx.addLabelsClose,
              onOnLabelDelete: _ctx.deleteLabel,
              "show-done-control": "",
              "is-photo": "",
              focus: "",
              class: "label-input__input"
            }, null, 8, ["onOnInputDone", "onOnLabelDelete"])
          ])
        ], 512))
      : _createCommentVNode("", true),
    (_ctx.isCreateCase)
      ? (_openBlock(), _createBlock(_component_drive_create_case, {
          key: 1,
          photos: _ctx.filesToUpload,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isCreateCase = false)),
          onCreate: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('on-close')))
        }, null, 8, ["photos"]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "#popup" }, [
      _createVNode(_component_app_cases_list_pop_up, {
        ref: "casesListModal",
        fileToUpload: _ctx.filesToUpload,
        labels: _ctx.labels,
        onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('on-close')))
      }, null, 8, ["fileToUpload", "labels"])
    ]))
  ]))
}